import { KK } from "@hid/define/define"
import { deviceManager } from "@hid/device/device_manager"
import { dataProfileManage } from "@hid/snapshot/profile"
import { KeysGroup, MagnetKeyInfo, postMagnetKeyInfo, PostMagnetSetKeyDeadZone, PostMagnetSetKeyInfo } from "@libs/types/response"

export const handleCalibration = async (data: { Value: boolean }) => {
    if (data.Value) {
        await deviceManager.deviceDriver.magnet?.startCalibration()
    } else {
        await deviceManager.deviceDriver.magnet?.endCalibration()
    }
}
export const handleTravels = async (data: { Keys: KK[] }) => {
    if (data.Keys.length == 0) {
        await deviceManager.deviceDriver.magnet?.endTravels()
    } else {
        await deviceManager.deviceDriver.magnet?.startTravels()
    }
}


export const handleSetKeyInfo = async (keyInfo: PostMagnetSetKeyInfo) => {
    if (keyInfo.PressNum == 0) throw new Error('按键行程, 不能为0')
    const config = dataProfileManage()
    keyInfo.Keys.forEach((value) => {
        config.dataProfile.MagnetTravel.set(value, {
            PressNum: keyInfo.PressNum, //第1个条的数值
            ReleaseNum: keyInfo.ReleaseNum, //第1个条的数值
            QuickTriggerPressNum: keyInfo.QuickTriggerPressNum, //第2个条的数值 如果没有填0
            QuickTriggerReleaseNum: keyInfo.QuickTriggerReleaseNum, //第3个条的数值 如果没有填0
        } as MagnetKeyInfo)
    });
    config.save()
    return await deviceManager.deviceDriver.magnet?.syncKeysTravels()
}

export const handleGetKeyInfo = async (kks: PostMagnetSetKeyInfo): Promise<postMagnetKeyInfo[]> => {
    return await deviceManager.deviceDriver.magnet?.getKeysTravels(kks.Keys) || []
}

export const handleGetKeysGroup = async () => {
    const config = dataProfileManage()
    if (config.dataProfile.KeysGroup == undefined || config.dataProfile.KeysGroup.length == 0) {
        config.dataProfile.KeysGroup = []
        config.save()
    }
    return config.dataProfile.KeysGroup
}


export const handleSetKeysGroup = async (list: KeysGroup[]) => {
    const config = dataProfileManage()
    // if (list.length == 0) {
    // throw new Error('按键组不能为空')
    // }
    config.dataProfile.KeysGroup = list
    config.save()
}


export const handleSetKeyDeadZone = async (data: PostMagnetSetKeyDeadZone) => {
    if (data.Keys.length == 0) throw new Error('按键不能为空')
    const config = dataProfileManage()
    data.Keys.forEach((value) => {
        config.dataProfile.DeadZoneList.set(value, { Top: data.Top, Bottom: data.Bottom })
    })
    config.save()
    return await deviceManager.deviceDriver.magnet?.syncKeysDeadZone()
}

export const handleGetKeyDeadZone = async (keys: KK[]) => {
    return await deviceManager.deviceDriver.magnet?.getKeysDeadZone(keys)
}
